interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | "…")[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | "…")[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("…");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("…");
  pages.push(total);
  return pages;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(currentPage, totalPages);

  const baseBtn =
    "min-w-9 h-9 px-3 rounded-md text-sm border transition-colors cursor-pointer whitespace-nowrap";

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={currentPage <= 1}
        onClick={() => onChange(currentPage - 1)}
        className={`${baseBtn} border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        上一页
      </button>

      {pages.map((page, i) =>
        page === "…" ? (
          <span key={`gap-${i}`} className="px-1 text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`${baseBtn} ${
              page === currentPage
                ? "border-primary-600 bg-primary-600 text-background-50"
                : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300"
            }`}
          >
            {page}
          </button>
        )
      )}

      <button
        type="button"
        disabled={currentPage >= totalPages}
        onClick={() => onChange(currentPage + 1)}
        className={`${baseBtn} border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        下一页
      </button>
    </nav>
  );
}